import { isNil } from 'lodash/fp';
/**
 * Alternative to Node.prototype.contains that should work regardless of the
 * environment (especially works for IE11)
 *
 * @param {Node} element - enclosing element
 * @param {Node} child - child element that might be contained withing
 *
 * @returns {boolean}
 * whether the child is contained within element
 *
 * @example
 *
 * if (containsNode(element, child)) {
 *    doSomething()
 * }
 */

export default function containsNode(element, child) {
  if (isNil(child)) {
    return false;
  }

  if (child === element) {
    return true;
  }

  return containsNode(element, child.parentNode);
}